import { put, takeEvery, call } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* getFaq({ payload: { signal, params } }) {
  try {
    const { data } = yield call(fetch, { api: api.help.faq, params, signal });

    yield put(actions.getFaqDone(data.results));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getFaqFailed,
      endpoint: api.help.faq
    });
  }
}

function* getDefinitions({ payload: { signal } }) {
  try {
    const { data } = yield call(fetch, { api: api.help.definitions, signal });

    yield put(actions.getDefinitionsDone(data.results));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getDefinitionsFailed,
      endpoint: api.help.definitions
    });
  }
}

export const getFaqSaga = takeEvery(types.GET_FAQ_REQUEST, getFaq);
export const getDefinitionsSaga = takeEvery(types.GET_DEFINITIONS_REQUEST, getDefinitions);